__turbopack_context__.v({
  "caption": "documentation-module__bnpMna__caption",
  "code": "documentation-module__bnpMna__code",
  "content": "documentation-module__bnpMna__content",
  "controls": "documentation-module__bnpMna__controls",
  "header": "documentation-module__bnpMna__header",
  "headerText": "documentation-module__bnpMna__headerText",
  "inner": "documentation-module__bnpMna__inner",
  "layout": "documentation-module__bnpMna__layout",
  "mono": "documentation-module__bnpMna__mono",
  "root": "documentation-module__bnpMna__root",
  "section": "documentation-module__bnpMna__section",
  "skipLink": "documentation-module__bnpMna__skipLink",
  "toc": "documentation-module__bnpMna__toc",
  "tocHeading": "documentation-module__bnpMna__tocHeading",
  "tocLink": "documentation-module__bnpMna__tocLink",
  "tocLinkActive": "documentation-module__bnpMna__tocLinkActive",
});
